<div>
  @if (data?.isAvailable && data.isArchived) {
    <span> {{ 'restore_to_setup_monitoring' | translate }}</span>
  } @else if (data?.isAvailable && !hasMonitoring && hasAccess) {
    <button
      ds-button
      [variant]="DsButtonVariants.microAction"
      [hideMicroActionIcon]="true"
      type="button"
      style="text-align: left"
      (click)="onSetupMonitoringClick($event)"
    >
      {{ 'set_up_monitoring' | translate }}
    </button>
  } @else if (data?.isAvailable && hasMonitoring) {
    <div class="monitoring-container">
      <button
        type="button"
        class="monitoring-label btn btn-link px-0 py-0 text-decoration-none"
        [appTooltip]="tooltipText"
        [attr.aria-label]="('label_monitoring' | translate) + ' - ' + tooltipText"
      >
        <ds-chip [text]="'label_monitoring' | translate"></ds-chip>
      </button>

      @if (alerts) {
        <app-monitoring-alert-icon class="margin-left" [alert]="alerts"></app-monitoring-alert-icon>
      }
    </div>
  } @else if (!data?.isAvailable && data.isArchived === false) {
    {{ 'not_supported' | translate }}
  }
</div>
